import { create } from 'zustand'
import { getMountEl } from '../utils/mountEl'

const savedTheme = localStorage.getItem('theme')
const initialDark = savedTheme !== 'light'   // dark por defecto

const applyTheme = (isDark) => {
  document.documentElement.classList.toggle('dark', isDark)
  // Además de <html>: cuando este bundle se monta dentro del shadow root
  // del shell unificado (quantum-web), un shadow boundary no hereda la
  // clase de <html> exterior -- los selectores `dark:` de Tailwind
  // necesitan la clase en un ancestro DENTRO del shadow tree. El elemento
  // raíz del árbol (ver utils/mountEl.js) es ese ancestro tanto en el
  // deploy standalone (chart.html) como embebido, así que replicar la
  // clase ahí cubre ambos casos sin romper ninguno.
  getMountEl()?.classList.toggle('dark', isDark)
  localStorage.setItem('theme', isDark ? 'dark' : 'light')
}

// Aplicar inmediatamente al cargar
applyTheme(initialDark)

const useUiStore = create((set) => ({
  sidebarOpen: true,
  isDark: initialDark,
  notifications: [],

  toggleSidebar: () => set((s) => ({ sidebarOpen: !s.sidebarOpen })),

  toggleTheme: () => set((s) => {
    applyTheme(!s.isDark)
    return { isDark: !s.isDark }
  }),

  addNotification: (notification) =>
    set((s) => ({
      notifications: [
        { id: Date.now(), ...notification },
        ...s.notifications.slice(0, 9),
      ]
    })),

  removeNotification: (id) =>
    set((s) => ({
      notifications: s.notifications.filter(n => n.id !== id)
    })),
}))

export default useUiStore
